import { Colors, getFont } from "@flatfile/design-system";
import { FlexCenter, FlexJustifyCenter } from "../../common/UI/Flex.js";
import styled from "styled-components";
const ModalText = styled.div`
  color: ${Colors.Pigeon700};
  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  gap: 1.25em;
  margin-top: 8px;
  margin-bottom: 8px;
`;
const BooleanGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
`;
styled.div`
  display: flex;
  gap: 1em;
  font-size: 0.85em;
  font-weight: 600;
`;
const LoadingSpinner = styled.div`
  height: 1.25em;
  width: 1.25em;
  color: ${({ theme }) => theme.loading.color};
  margin-left: 0.5em;
`;
const Wrapper = styled.div`
  ${FlexCenter};
  height: 100%;
  font-size: 0.85em;
  padding: 0.5em 0 0.5em 0.5em;
  color: ${({ theme }) => theme.filters.color};
  font-weight: 600;
`;
const ErrorContainer = styled.div`
  margin-top: 1rem;

  div {
    gap: 0;
  }
`;
const DropdownWrapper = styled.div`
  position: relative;

  input {
    ${(props) => props.hasNoneMessage && `
      border-bottom-right-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    `}
  }

  ul {
    ${(props) => props.hasMaxMessage && `padding-top: 28px;`}
  }
`;
const DropdownMessage = styled.div`
  ${getFont("it1")}
  position: absolute;
  top: 68px;
  z-index: 40;
  padding: 2px 0.75em;
  color: ${(props) => props.theme.lookupEditor.color};
  width: 100%;
  background-color: ${Colors.Pigeon100};
  border-bottom: 1px solid ${Colors.Pigeon200};
  border-right: 1px solid ${Colors.Pigeon400};
  border-left: 1px solid ${Colors.Pigeon400};

  ${(props) => props.none && `
    margin-top: -1px;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
    border-bottom: 1px solid ${Colors.Pigeon400};
    border-top: 1px solid ${Colors.Pigeon200};
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  `}
`;
const TextInputWrapper = styled.div`
  padding-bottom: 0.5rem;
`;
const CheckboxContainer = styled.div`
  display: inline-block;
  position: relative;
  padding-top: 0.25rem;

  div {
    gap: 0.5rem;
  }
`;
const HintWrapper = styled.div`
  font-size: 0.75rem;
  padding-top: 0.25rem;
  color: ${({ error }) => error ? Colors.Pinata900 : Colors.Pigeon600};
`;
const AlertIconWrapper = styled.div`
  ${FlexJustifyCenter};
  height: 2.5em;
  width: 2.5em;
  margin-top: 0.375em;
  border-radius: ${(props) => props.theme.icon.borderRadius};
  background-color: ${Colors.Pinata100};
  flex-shrink: 0;

  svg {
    color: ${Colors.Pinata900};
  }
`;
const AlertContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1em;
`;
const FilteredContainer = styled.div`
  margin-top: 0.5em;
`;
export {
  AlertContentWrapper,
  AlertIconWrapper,
  BooleanGroup,
  CheckboxContainer,
  DropdownMessage,
  DropdownWrapper,
  ErrorContainer,
  FilteredContainer,
  HintWrapper,
  LoadingSpinner,
  ModalText,
  TextInputWrapper,
  Wrapper
};
